export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10076.d340a48c.jpg";